<div fxLayout="row">
    <forge-icon-button *ngIf="hasEditFunction" [disabled]="!canEdit()" (click)="fireCustomFunction()" telemetry="Submission-Edit">
        <forge-tooltip placement="bottom">Edit</forge-tooltip>
    <forge-icon name="edit"></forge-icon>
        </forge-icon-button>

    <forge-icon-button *ngIf="showDelete()" [disabled]="!canDelete()" (click)="delete()" telemetry="Submission-Delete">
        <forge-tooltip placement="bottom">Delete</forge-tooltip>
    <forge-icon name="delete"></forge-icon>
        </forge-icon-button>

    <metadata-action *ngFor="let action of primaryActions" [action]="action" [model]="model" enable-shortcut="false" (actionCallback)="afterActionCallback($event)">
    </metadata-action>

    <command-menu *ngIf="hasOverflowActions()" [commands]="commands" icon="more_vert" always-show-icon="true" fxLayout="row" fxLayoutAlign="space-between center" position="target-right bottom" aria-label="More Grid Actions">
    </command-menu>
</div>
